import { Typography } from '@ghq-abi/design-system-v2';
import { Download, FileText } from 'lucide-react';

interface AttachmentDownloadRowProps {
  fileName: string;
  onDownload: () => void;
  disabled?: boolean;
  className?: string;
}

export function AttachmentDownloadRow({
  fileName,
  onDownload,
  disabled = false,
  className = 'flex items-center justify-between gap-3 border-b border-gray-200 pb-2 last:border-0 last:pb-0'
}: AttachmentDownloadRowProps) {
  return (
    <div className={className}>
      <button
        type="button"
        onClick={onDownload}
        disabled={disabled}
        className="flex min-w-0 items-center gap-2 text-left text-gray-900 hover:text-blue-700 cursor-pointer disabled:cursor-not-allowed disabled:opacity-60">
        <FileText className="h-4 w-4 flex-shrink-0" />
        <Typography
          variant="metadata-sm-medium"
          color="dark"
          as="span"
          className="truncate">
          {fileName}
        </Typography>
      </button>
      <Download className="h-4 w-4 text-gray-500 flex-shrink-0" />
    </div>
  );
}
